import React from 'react';
import useIntls from '@opm/hooks/useIntls';
import { DefaultImg } from '@op/constants/defaultImg';
import AISummaryBlock from '../../components/AISummaryBlock';
import { ITrendItem } from '../../types';

interface IAISummaryProps {
  record: ITrendItem | null;
}

/**
 * Drawer AI Summary 区（Figma 3902_62017 Section 2）
 *
 * 标题外置布局：AI icon + "AI Summary" 在面板外
 * 渐变面板委托 AISummaryBlock 渲染（hasTitle=false）
 */
export default function AISummary({ record }: IAISummaryProps) {
  const { intl } = useIntls();

  return (
    <div className="dbom-ct-drawer-summary">
      <div className="dbom-ct-drawer-summary__header">
        <img
          src={DefaultImg.AI}
          alt=""
          className="dbom-ct-drawer-summary__icon"
        />
        <span className="dbom-ct-drawer-summary__title">
          {intl('AI Summary')}
        </span>
      </div>
      <AISummaryBlock summaryData={record} hasTitle={false} />
    </div>
  );
}
